// For /user-panel/orders/orders
const ordersList = {
    status: [
        {
            text: 'Order status',
            value: null
        },
        // {
        //     text: 'Reserved',
        //     value: 'inventory_reserved'
        // },
        {
            text: 'In progress',
            value: 'inventory_reserved,completed'
        },
        // {
        //     text: 'Shipped',
        //     value: 'shipped'
        // },
        // {
        //     text: 'Packed',
        //     value: 'packed'
        // },
        // {
        //     text: 'Sent',
        //     value: 'sent'
        // },
        // {
        //     text: 'Delivered',
        //     value: 'delivered'
        // },
        // {
        //     text: 'Received',
        //     value: 'received'
        // },
        {
            text: 'Completed',
            value: 'packed'
        },
        {
            text: 'Canceled',
            value: 'canceled'
        },
    ],
    salesChannel: [
        {
            text: 'Sales channel',
            value: null
        },
        {
            text: 'Amazon',
            value: 'amazon'
        },
        {
            text: 'Shopify',
            value: 'shopify'
        },
        {
            text: 'EBay',
            value: 'ebay'
        },
        {
            text: 'Etsy',
            value: 'etsy'
        },
        {
            text: 'Boxiti',
            value: 'boxiti'
        },
    ],
}

module.exports = {
    ordersList
}



// WEBPACK FOOTER //
// ./src/assets/js/table-options/orders.js